import { Controller, useFormContext } from 'react-hook-form';

import { Field, RadioButtonGroup } from '@grafana/ui';
import { t } from 'app/core/internationalization';
import { ReportBaseV2, SendTime } from 'app/extensions/types/reports';

const sendTimeOptions = [
  { label: 'Send now', value: SendTime.Now },
  { label: 'Send later', value: SendTime.Later },
];

export function SendTimeOptions() {
  const { control } = useFormContext<ReportBaseV2>();

  return (
    <Field label={t('share-report.schedule.send-time', 'Schedule')}>
      <Controller
        control={control}
        name="schedule.sendTime"
        render={({ field: { ref, ...rest } }) => <RadioButtonGroup fullWidth {...rest} options={sendTimeOptions} />}
      />
    </Field>
  );
}
